export default {
  home: {
    sectionOne: {
      badge: 'Rede latino-americana de mitocrítica',
      title:
        'Nossa rede é internacional e reúne pesquisadores de vários países em torno do estudo da mitocrítica e suas relações com a cultura',
      description:
        'Organizamos seminários mensais, colóquios e congressos internacionais e promovemos trocas, intercâmbios e parcerias entre instituições de ensino e pesquisa, grupos de pesquisa, pesquisadores e estudantes'
    },
    sectionTwo: {
      badge: 'Quem somos',
      title: 'Bem-vindo à Rede Pachamama',
      description:
        'A Rede Latino-americana de Mitocrítica Pachamama é uma rede de pesquisadores que têm em comum o interesse pelo estudo dos mitos e de suas relações com as dinâmicas culturais latino-americanas. Tem sede na Universidade de Porto Rico em Bayamón e está em atividade desde fevereiro de 2023',
      cards: {
        seminary: {
          title: 'Seminários',
          summary: 'Seminários online mensais exclusivos para membros da Rede Pachamama'
        },
        colloquia: {
          title: 'Colóquios',
          summary: 'Colóquios internacionais realizados pela Rede Pachamama'
        },
        community: {
          title: 'Comunidade',
          summary: 'Comunidade integrada com o objetivo de compartilhar trabalhos e conhecimento'
        },
        partnership: {
          title: 'Parcerias',
          summary: 'Parcerias com Redes de outros países para maior divulgação e mais conexões'
        }
      }
    },
    sectionThree: {
      badge: 'Os pesquisadores',
      title: 'Conheça os nossos integrantes',
      associate: {
        female: 'Associada',
        male: 'Associado'
      },
      president: {
        female: 'Presidenta',
        male: 'Presidente'
      },
      founder: {
        male: 'Fundador',
        female: 'Fundadora'
      },
      secretary: {
        female: 'Secretária',
        male: 'Secretário'
      },
      moreAboutUs: 'Saiba mais sobre nós'
    },
    sectionFour: {
      badge: 'Parceiras',
      title: `Conheça nossos<br />parceiros`,
      description:
        'A Rede Pachamama nasce no intuito de fomentar trocas, encontros, diálogos e parcerias. Algumas instituições parceiras já apoiam a rede e esperamos que venham mais!',
      asteria:
        'Associação internacional de mitocrítica com sede na Universidade Complutente de Madrid',
      portoRico:
        'Instituição sede da Rede Pachamama, do VIII Congresso Internacional de Mitocrítica e I Colóquio de Mitocrítica Latinoamericana da Rede Pachamama',
      ucb: 'O Mestrado Profissional Inovação em Comunicaçãoe Economia Criativa colabora com a rede Pachamama, especialmente por meio do grupo de pesquisa Travessias - Transdisciplinaridade e Criatividade, dedicado aos estudos do imaginário, dos mitos e da imaginação'
    },
    sectionFive: {
      title: 'Perguntas frequentes',
      description: `Encontre respostas rápidas e claras sobre quem somos e o que fazemos. Se sua pergunta não estiver aqui, <Link href="{{link}}">entre em contato conosco</Link>`,
      faqsLink: {
        answer:
          'Para se associar, basta <Link to="/">clicar aqui</Link>, preencher o formulário, anexar uma foto e aguardar o retorno da diretoria. Se sua solicitação for aprovada, receberá a indicação de como  realizar o pagamento da anuidade.'
      },
      faqs: [
        {
          question: 'Quem pode fazer parte da rede Pachamama?',
          answer:
            'Qualquer pessoa interessada na mitocrítica latino-americana, seja estudante de graduação ou pós-graduação, pesquisador, professor, artista ou profissional independente.'
        },
        {
          question: 'Como posso me associar?',
          answer: ''
        },
        {
          question: 'Como ficarei informado das atividades da rede?',
          answer:
            'Ao preencher o formulário, é solicitada a indicação de um e-mail onde gostaria de receber as informações e de um número de telefone com WhatsApp opcional se quiser fazer parte do grupo.'
        },
        {
          question: 'Que benefícios terei ao me associar?',
          answer:
            'Você receberá por e-mail e/ou WhatsApp todas as informações relativas às atividades da rede; poderá participar dos seminários regulares como ouvinte e/ou apresentador; terá 50% de desconto na inscrição do Congresso Internacional e dos Colóquios; poderá propor parcerias, intercâmbios e outros convênios a outros membros da rede.'
        },
        {
          question: 'Há restrição de nacionalidade dos membros?',
          answer:
            'Não. Toda pessoa interessada na mitocrítica latino-americana pode fazer parte, independente de sua nacionalidade ou vínculo com uma instituição latino-americana.'
        },
        {
          question: 'Posso ter isenção do pagamento da anuidade?',
          answer:
            'Sim. Para tanto, deverá enviar uma solicitação justificada ao e-mail redlat.mitocritica@upr.edu. A solicitação será analisada pelos membros da diretoria e poderá ou não ser atendida'
        },
        {
          question: 'Quais as obrigações do associado?',
          answer:
            'Apenas o pagamento da anuidade é obrigatório. Todas as outras atividades são opcionais.'
        }
      ]
    }
  },
  members: {
    institution: 'Instituição',
    interest: 'Áreas de interesse',
    usefulLinks: 'Links úteis',
    associate: {
      female: 'Associada',
      male: 'Associado'
    },
    president: {
      female: 'Presidenta',
      male: 'Presidente'
    },
    founder: {
      female: 'Fundadora',
      male: 'Fundador'
    },
    secretary: {
      female: 'Secretária',
      male: 'Secretário'
    },
    sectionOne: {
      title: 'Presidência',
      presidents: {
        florence: {
          institution:
            'Programa de Pós-Graduação Inovação em Comunicação e Economia Criativa.  Universidade Católica de Brasília, Brasil.',
          interest:
            'Estudos do mito; estudos do imaginário; poesia e imaginação; imersão; narrativa; mitos femininos; mitologia indígena; mitologia afro-brasileira.'
        },
        gabriel: {
          institution:
            'Mestrado em Educação e DDHH pela Universidad Autonoma Latinoamericana, Medellin Colombia.',
          interest: 'Arte, Memória Histórica, Mito e Símbolo.'
        }
      }
    },
    sectionTwo: {
      title: 'Fundadores',
      founders: {
        aleida: {
          institution: 'Universidade de Porto Rico em Bayamón, Departamento de Humanidades.',
          interest:
            'Mitocrítica; Hermenéutica; Fenomenología; Existencialismo; Filosofía del paisaje; Ética ambiental.'
        },
        cristina: {
          institution: 'Investigadora independente',
          interest:
            'Literaturas de irrealidade iberoamericanas; Discurso fantástico contemporâneo; Literatura fantástica; Narrativa apocalíptica; Mitocrítica.'
        },
        luisAlberto: {
          institution:
            'Departamento de Artes e Humanidades do Centro Universitário do Sul da Universidade de Guadalajara (México).',
          interest:
            'Mitocrítica; Mitocrítica latino-americana; Mitocrítica cultural; Teoria do imaginário; Imaginário e representações artísticas.'
        },
        luisOwen: {
          institution: 'Universidade de Porto Rico em Bayamón, Departamento de Humanidades.',
          interest:
            'Filosofia bergsoniana da religião (o mito segundo Bergson); Deus como problema filosófico; Antropologia filosófica.'
        },
        luisPablon: {
          institution: 'Universidade de Porto Rico em Bayamón - Departamento de Humanidades',
          interest: 'Mitologia, História e Filosofia'
        },
        duda: {
          institution: 'Centro de Estudos Humanísticos Universidade do Minho, Braga, Portugal.',
          interest: 'Mitos; Cosmogonias; Mitocrítica.'
        },
        miriam: {
          institution:
            'Universidade de Sorocaba; Programa de Pós-Graduação em Comunicação e Cultura.',
          interest: 'Narrativas; Expressões culturais do mito.'
        }
      }
    },
    sectionThree: {
      title: 'Associados',
      associates: {
        andriolli: {
          institution:
            'Universidade Estadual do Rio de Janeiro – UERJ/ Brasil - Faculdade de Comunicação Social.',
          interest: 'Mito, Imaginário, Oralidade, Folclore.'
        },
        vanessa: {
          institution: 'Instituto Politécnico Nacional (IPN) - México.',
          interest: 'Escatologia; Mitos mexicanos; Animalidade'
        },
        navi: {
          institution:
            'Fundação Ética Visionária. Conselho de Educação. Coordenadora para a América Central.',
          interest:
            'Estética Relacional, etnoficção, cinematografia, performance, ficção científica.'
        },
        mabel: {
          institution:
            'Universidade da Fronteira, Departamento de Línguas, Literatura e Comunicação. Temuco, Chile.',
          interest:
            'Pensamento mítico na literatura e arte indo-americana e literatura e arte mapuche.'
        },
        gustavo: {
          institution: 'Universidade de Brasília, PPGCOM/FAC.',
          interest:
            'Poesia, Literatura, Personagem, Mito, Sagrado, Deuses, Mídia, Comunicação, Religiosidade popular, Imaginário, Biografia.'
        },
        jose: {
          institution:
            'Universidade Nacional Autônoma do México, Faculdade de Filosofia e Letras, Colégio de Letras Hispânicas.',
          interest: 'Língua e Literaturas Hispânicas; Mito; Metaforologia; Ficção; Imaginação.'
        },
        hertz: {
          institution:
            'Universidade Federal do Paraná (UFPR), Departamento de Comunicação, Programa de Pós-graduação em Comunicação (PPGCOM-UFPR).',
          interest:
            'Mito; Consumo e Cultura Midiática; Arte, Mito e Mídia; Mito, Consumo e Imaginário; Mito, Religião e Imaginário Cultural.'
        },
        alan: {
          institution: 'Universidade de Brasília - UnB',
          interest: 'Circularidades; Cultos ancestrais; Culturas ameríndias e afrodiaspóricas.'
        },
        alvaro: {
          institution: 'Universidade de Antioquia - Faculdade de Educação',
          interest: ' Educación; Educación popular; Diversidad epistémica; Narrativa.'
        }
      }
    }
  },
  seminar: {
    sectionOne: {
      title: 'Seminários regulares',
      seeMore: 'Veja mais no nosso canal',
      description:
        'Os seminários acontecem regularmente ao longo do ano, todo primeiro sábado do mês, às 13h (horário de Brasília), de forma remota. A agenda é construída conjuntamente ao início de cada semestre. Todos os membros da Rede podem apresentar seus trabalhos de pesquisa e/ou sugerir nomes de convidados. O convite com o link é enviado por e-mail e é feita uma divulgação em nosso Instagram. Os Seminários regulares são abertos ao público.'
    },
    sectionTwo: {
      indicator: 'Vídeos 2023'
    },
    sectionThree: {
      indicator: 'Vídeos 2024'
    },
    seminar: 'Seminário',
    host: {
      male: 'Apresentador',
      female: 'Apresentadora',
    }
  },
  'become-member': {
    title: 'Faça parte da rede <br /> Pachamama',
    description:
      'Se você é pesquisador, professor, estudante ou artista interessado em discutir, fazer parceria, fortalecer as trocas acadêmicas em torno da mitocrítica na América Latina, junte-se a nós. Você receberá por e-mail e/ou whatsapp todas as informações sobre as atividades da rede; poderá participar dos seminários regulares como ouvinte e/ou apresentador; terá desconto na inscrição aos congressos internacionais e colóquios; poderá propor parcerias, intercâmbios e outros convênios aos membros da rede e fortalecer sua internacionalização na América Latina.',
    cards: {
      seminary: {
        title: 'Seminários',
        summary: 'Seminários online mensais exclusivos para membros da Rede Pachamama'
      },
      colloquia: {
        title: 'Colóquios',
        summary: 'Colóquios internacionais realizados pela Rede Pachamama'
      },
      community: {
        title: 'Comunidade',
        summary: 'Comunidade integrada com o objetivo de compartilhar trabalhos e conhecimento'
      },
      partnership: {
        title: 'Parcerias',
        summary: 'Parcerias com Redes de outros países para maior divulgação e mais conexões'
      }
    },
    becomeMemberButton: 'TORNAR-SE MEMBRO'
  },
  'who-we-are': {
    title: 'Quem somos',
    card: {
      origin: {
        title: 'A Origem',
        info: `
          <p>
            <strong>A Rede Latino-americana de Mitocrítica Pachamama</strong> 
            nasceu de um encontro casual: em outubro de 2022, durante o Congresso 
            Internacional de Mitocrítica convocado pela rede Asteria, na 
            Universidade Complutense de Madrid, um grupo de pesquisadores de 
            países latino-americanos se perguntou por que não havia uma rede 
            que se dedicaria ao estudo dos mitos dos nossos respectivos países 
            numa perspectiva multidisciplinar.
          </p>

          <p>
            A partir dessas conversas, concordamos que a riquíssima tradição 
            mítica que herdamos na América não só faz parte das nossas histórias 
            nacionais como, de muitas formas, une todo o continente sob uma história 
            comum: a dos <strong>nossos antepassados indígenas</strong>, a sua visão de mundo, as 
            suas crenças e uma série de tradições que mostram a vitalidade e a 
            presença constante desse passado no presente da América Latina. É 
            claro que os acontecimentos que moldaram cada idiossincrasia, os 
            diversos fluxos migratórios e a história particular de cada país, 
            a forma de criar novos mitos e de sincretizar o ameríndio com a 
            herança europeia, africana ou asiática (não podemos esquecer a 
            imigração gradual ou forçada de importantes grupos da Ásia) 
            fornecem nuances que tornam a produção cultural americana ainda 
            mais complexa.
          </p>

          <p>
            Por último, concordamos que o estudo dos mitos a partir da Academia 
            (com A maiúsculo) se limita, em grande medida, à Antiguidade clássica 
            (Grécia e Roma), à tradição hindu, a algumas histórias nórdicas e 
            pouco mais: <strong>a América tem sido praticamente invisível para a 
            mitocrítica e era preciso fazer alguma coisa.</strong>
          </p>
        `
      },
      network: {
        title: 'A Rede',
        info: `
          <p>
            No dia <strong>4 de fevereiro de 2023</strong>, nove de nós reunimo-nos a partir do
            nosso local de residência, por estrita ordem alfabética: Gabriel
            Caldas (Bogotá, Colômbia), Luis Canting Placa (Bayamón, Porto Rico),
            Miriam Carlos Silva (Sorocaba, Brasil), Florence Dravet
            (Brasília, Brasil), Eduarda Filomeno Affonso (Braga, Portugal),
            Aleida Gelpí Acosta (Bayamón, Porto Rico), Cristina Mondragón
            (Lausanne, Suíça), Luis H. Pabón Batlle (Bayamón, Porto Rico) e
            Luis Alberto Pérez Amezcua (Guadalajara, México) e decidimos formar
            a Rede Latino-americana de Mitocrítica. Mas precisávamos de um nome,
            não só para nos identificar como grupo, mas também para nos
            referirmos ao nosso objetivo: o estudo dos mitos latino-americanos
            antigos e atuais. Alguém sugeriu o nome Pachamama e este pegou:
            nasceu o germe da nossa rede.
          </p>

          <p>
            Poucos dias depois, graças aos esforços de Luis Pabón Batlle,
            a Universidade de Porto Rico em Bayamón recebeu-nos como sede
            acadêmica e o grupo de investigação foi oficializado com o nome de
            <strong>Pachamama Rede Latino-americana de Mitocrítica</strong>.
          </p>
        `
      },
      why: {
        title: 'Por que Pachamama?',
        info: `
          <p>
            <strong>Pachamama</strong> é a Huaca (a manifestação sagrada) da terra na religião
            quechua, a deusa que nos dá a vida e nos recebe de volta com a morte,
            mãe das restantes divindades e do cosmos. É uma deusa telúrica, na
            medida em que é nela que vivemos, dela que nos alimentamos e aos
            animais não humanos com quem convivemos, e é também ctônica porque
            abriga o mundo subterrâneo, cujas entradas (as cavernas) são
            simultaneamente abrigo e túmulo. Guarda o fogo dos vulcões, a força
            dos terremotos e as nascentes dos rios; representa a fertilidade,
            a criação e a natureza que cuida e mantém. Como muitas das
            divindades antigas, Pachamama também foi identificada com a mãe do
            deus dos invasores, a Virgem Maria, outra figura poderosa que
            intercede entre os seres humanos e o Deus que herdamos dos europeus.
            Ela é, portanto, a Huaca da tradição ameríndia original, a Mãe de
            Deus da América cristianizada e o símbolo da terra, da vida e da
            morte. Que melhor figura tutelar para o nosso grupo de mitólogos?
            <strong>A Pachamama representa a parte do mito viva e atuante com que convivemos todos os dias na América Latina.</strong>
          </p>
        `
      }
    }
  },
  magazines: {
    title: 'Revistas',
    magazines: {
      contemplator: 'Revista Universi <br /> Contemplator',
      esfera: 'Revista Esferas',
      amaltea: 'Revista Amaltea',
      accessButton: 'Acessar Site',
    }
  },
  colloquies: {
    title: 'Colóquios',
    card: {
      title: 'VIII Congresso Internacional de Mitocrítica e I Colóquio internacional da Rede Pachamama',
      date: '29 a 31 de outubro de 2024',
      description: 'A fim de inaugurar o debate em torno de reflexões comuns sobre mito e mitocrítica latinoamericana, Pachamama RLM e Asteria AIM se uniram neste VIII Congreso e I Colóquio e convidam pesquisadores interessados a enviar propostas em torno das seguintes linhas temáticas ou temas afins:',
      list: [
        'Mito e questões epistemológicas',
        'Expressões culturais do mito',
        'O mito e seus alcances políticos',
      ],
      button: 'Mais informações e inscrição ',
    }
  },
  'in-construction': {
    title: 'PÁGINA EM CONSTRUÇÃO',
    description: 'Esta página ainda não está disponível. Por favor, volte em outro momento para encontrar os nossos conteúdos. Obrigado pela sua compreensão.',
  }
};
